import React from 'react';
import { Button } from '@/components/ui/button';

export interface ActionsSectionProps {
  onApply: () => void;
  onCancel: () => void;
}

export const ActionsSection: React.FC<ActionsSectionProps> = ({
  onApply,
  onCancel,
}) => {
  return (
    <div className="flex justify-end gap-2 pt-2 border-t border-border">
      <Button size="sm" variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button size="sm" onClick={onApply}>
        Apply
      </Button>
    </div>
  );
};
